// @ts-strict-ignore
import React from 'react'
import ReactDOM from 'react-dom'

export interface IPortalProps {
  id: string
  fallback?: boolean
  children: React.ReactNode
}

let i = 1

function Portal(props: IPortalProps) {
  const { id, fallback, children } = props
  const [target, setTarget] = React.useState<HTMLElement>(null)
  const targetDepId = target ? 0 : i++ // pop useEffect on every render until the container is found (sometimes needed)

  React.useEffect(() => {
    setTarget(document?.getElementById(id))
  }, [id, targetDepId])

  React.useEffect(() => {
    // this is a workaround for when the targeted container is in a different component subtree
    // in this case, it can update, mount, unmount without the current component subtree updating at all
    // this is normal and can happen at any time
    const testIntervalHandle = window.setInterval(() => {
      let newTarget = document?.getElementById(id)

      if (newTarget && newTarget !== target) {
        setTarget(newTarget)
      }
    }, 250)

    return () => window.clearInterval(testIntervalHandle)
  }, [target, id])

  if (!target) {
    if (fallback) {
      return (
        <React.Fragment>
          {children}
        </React.Fragment>
      )
    }

    return null
  }

  return ReactDOM.createPortal(children, target)
}

export default React.memo(Portal)
